import { createFileRoute } from "@tanstack/react-router";
import ShowroomGltfImportPerformanceDebug from "lib/components/debug/ShowroomGltfImportPerformanceDebug";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../components/withAuthentication";

function ShowroomGltfImportPerformanceDebugPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Showroom GLTF Import Performance Debug")}</title>
        <meta name="robots" content="noindex" />
      </Head>

      <ShowroomGltfImportPerformanceDebug />
    </>
  );
}

export const Route = createFileRoute("/debug/showroom-gltf-import-performance")({
  component: withAuthentication(ShowroomGltfImportPerformanceDebugPage, { superAdmin: true }),
});
